import React from 'react';
import {
  Fastfood,
  FitnessCenter,
  LocalDrink,
  Mood,
  MedicalServices,
  Assignment,
  EventNote,
} from '@mui/icons-material';
import { AnyEvent, EventType, Expert } from './types';

// ─── Experts ──────────────────────────────────────────────────────────────────

export const EXPERT_NUTRITION: Expert  = { name: 'Марія К.',  initials: 'МК', color: '#2e7d32' };
export const EXPERT_TRAINING: Expert   = { name: 'Олег Т.',   initials: 'ОТ', color: '#1565c0' };
export const EXPERT_MOTIVATION: Expert = { name: 'Ірина С.',  initials: 'ІС', color: '#6a1b9a' };

// ─── Category meta ────────────────────────────────────────────────────────────

export const CATEGORY_LABELS: Record<EventType, string> = {
  food:        'Харчування',
  workout:     'Активність',
  liquid:      'Вода',
  feeling:     'Самопочуття',
  medication:  'Препарат',
  task:        'Задача',
  appointment: 'Зустріч',
};

export const CATEGORY_META: Record<EventType, { icon: React.ReactNode; color: string }> = {
  food:        { icon: <Fastfood fontSize="small" />,        color: '#ff8f00' },
  workout:     { icon: <FitnessCenter fontSize="small" />,   color: '#d32f2f' },
  liquid:      { icon: <LocalDrink fontSize="small" />,      color: '#0288d1' },
  feeling:     { icon: <Mood fontSize="small" />,            color: '#7b1fa2' },
  medication:  { icon: <MedicalServices fontSize="small" />, color: '#388e3c' },
  task:        { icon: <Assignment fontSize="small" />,      color: '#00796b' },
  appointment: { icon: <EventNote fontSize="small" />,       color: '#c62828' },
};

// ─── Quick add ────────────────────────────────────────────────────────────────

export const QUICK_ADD: { type: EventType; label: string }[] = [
  { type: 'liquid',     label: 'Вода'       },
  { type: 'food',       label: 'Їжа'        },
  { type: 'workout',    label: 'Активність' },
  { type: 'medication', label: 'Препарат'   },
  { type: 'feeling',    label: 'Думки'      },
  { type: 'task',       label: 'Задача'     },
];

// ─── Summary ──────────────────────────────────────────────────────────────────

export const SUMMARY = {
  calories: { current: 1240, goal: 1821, pct: 68, emoji: '⚡', label: 'ккал' },
  water:    { current: 400,  goal: 1588, pct: 25, emoji: '💧', label: 'мл'   },
  activity: { current: 45,   goal: 304,  pct: 15, emoji: '🔥', label: 'хв'   },
};

// ─── Mock events ──────────────────────────────────────────────────────────────

export const MOCK_EVENTS: AnyEvent[] = [
  { id: 1,  time: '08:10', type: 'food',       title: 'Макарони на молоці',                                               completed: true,  fromExpert: false },
  { id: 2,  time: '08:10', type: 'workout',     title: 'Зарядка',                                                          completed: false, fromExpert: false },
  { id: 3,  time: '09:00', type: 'workout',     title: 'Прогулянка 30 хв на свіжому повітрі',                              completed: false, fromExpert: true, expert: EXPERT_TRAINING },
  { id: 4,  time: '09:00', type: 'food',        title: 'Сніданок: вівсянка 200г + ягоди',                                  completed: false, fromExpert: true, expert: EXPERT_NUTRITION },
  { id: 5,  time: '10:56', type: 'food',        title: 'Американо',                                                        completed: true,  fromExpert: false },
  { id: 6,  time: '11:00', type: 'task',        title: '💪 Ти вже на половині шляху до мети! Не зупиняйся',                completed: true,  fromExpert: true, expert: EXPERT_MOTIVATION },
  { id: 7,  time: '12:30', type: 'food',        title: 'Обід: куряча грудка з рисом, 400г',                                completed: false, fromExpert: true, expert: EXPERT_NUTRITION },
  { id: 8,  time: '13:55', type: 'workout',     title: 'Прогулянка моя',                                                   completed: true,  fromExpert: false },
  { id: 9,  time: '14:00', type: 'medication',  title: 'Магній 300мг — денний прийом',                                     completed: false, fromExpert: true, expert: EXPERT_NUTRITION },
  { id: 10, time: '17:00', type: 'workout',     title: 'Силове тренування: присідання 3×15, жим 3×12',                    completed: false, fromExpert: true, expert: EXPERT_TRAINING },
  { id: 11, time: '20:18', type: 'liquid',      title: 'Вода 200мл',                                                       completed: true,  fromExpert: false },
  { id: 12, time: '20:45', type: 'liquid',      title: 'Вода 200мл',                                                       completed: true,  fromExpert: false },
  { id: 13, time: '21:08', type: 'feeling',     title: 'В програмі не вистачає можливості зафіксувати похід до лікаря',    completed: true,  fromExpert: false },
  { id: 14, time: '21:32', type: 'workout',     title: 'Міні тренування: 10 віджимань, 10 присідань, 10 скручувань',       completed: true,  fromExpert: false },
  { id: 15, time: '22:00', type: 'medication',  title: 'Магній 300мг — вечірній прийом',                                   completed: false, fromExpert: true, expert: EXPERT_NUTRITION },
  { id: 16, time: '22:06', type: 'feeling',     title: 'Нагадування про воду живуть своїм життям. Вилазять по кілька штук підряд коли повертаюся в додаток', completed: true, fromExpert: false },
  { id: 17, time: '18:00', type: 'task',        title: 'Записатися до стоматолога',                                         completed: false, fromExpert: false },
];
